import React, { useState } from 'react';
import { isMobile, isMobileWithOutIpad } from '@helpers/EnvHelper';
import { isEmpty as _isEmpty } from 'lodash';
import SlideVideo from '@molecules/slider/SlideVideo';
import SlideYoutube from '@molecules/slider/SlideYoutube';

/* 메인 키비쥬얼 타입:유투브 */
const YoutubeBanner = ({ data, onPlay, setOnPlay, setCurrentYoutubeRef }) => {
  let visualStyle = isMobileWithOutIpad() ? 'pt-[153.6%]' : 'pt-[56.25%]';

  return (
    <>
      <div className="relative z-20 w-full max-w-[1920px] max-h-[870px] overflow-hidden">
        <div className={visualStyle} />
        <div className="absolute top-0 left-0 flex flex-col justify-center items-center w-full h-full">
          <div className="w-full h-full absolute bg-black"></div>
          <div className="w-full h-full max-w-[1920px] relative z-20">
            <SlideYoutube
              videoId={data.youtubeUrl}
              poster={
                isMobile() &&
                !_isEmpty(data.moImageSrc) &&
                data.moImageSrc.length > 1
                  ? data.moImageSrc
                  : data.imageSrc
              }
              onPlay={onPlay}
              setOnPlay={setOnPlay}
              setCurrentYoutubeRef={setCurrentYoutubeRef}
              bgBlackYN="Y"
            />
          </div>
        </div>
      </div>
      <div className="absolute w-full h-full overflow-hidden">
        <img
          src="/img/img-main@3x.png"
          alt=""
          className="blur-[50px] scale-110"
        />
        <div className="w-full h-full absolute bg-black top-0 left-0 opacity-50"></div>
      </div>
      {/* <iframe width="100%" height="100%" title="banner" src={`https://www.youtube.com/embed/${row.youtubeUrl}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                        </iframe> */}
    </>
  );
};

export default YoutubeBanner;
